import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root'
})
export class StudentManagementService {
  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private snackbar: MatSnackBar
  ) { }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 2500 });
  }
  getFieldsForAdmission(fieldsList: any[]) {
    let map = {};

    for(let field of fieldsList) {
      for(let fieldGroup of field.fieldGroup) {
        if(!fieldGroup.fieldStepId)
          continue;

        let stepName = fieldGroup.fieldStepName ? fieldGroup.fieldStepName : 'undefined';
        let groupName = fieldGroup.fieldGroupName;

        if(!map[stepName]) {
          map[stepName] = {};
        }
        if(!map[stepName][groupName]) {
          map[stepName][groupName] = [];
        }
        field['fieldStepId'] = fieldGroup.fieldStepId;
        field['fieldGroupId'] = fieldGroup.fieldGroupId;

        const newField = JSON.parse(JSON.stringify(field));
        map[stepName][groupName].push(newField);
      }
    }

    return map;
  }

  getFieldsForDisplay(fieldsList: any[]) {
    let map = {};

    for(let field of fieldsList) {
        if(!field.fieldStepId)
          continue;

        let stepName = field.fieldStepName ? field.fieldStepName : 'undefined';
        let groupName = field.fieldGroupName;

        if(!map[stepName]) {
          map[stepName] = {};
        }
        if(!map[stepName][groupName]) {
          map[stepName][groupName] = [];
        }
        field['fieldStepId'] = field.fieldStepId;
        field['fieldGroupId'] = field.fieldGroupId;

        map[stepName][groupName].push(field);

    }

    return map;

  }

  createAdmission(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/registration/admission?registrationId=${payload?.registrationId || ''}`, payload
    )
  }

  createPaymentForAdmission(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/registration/admission/payment`, payload
    )
  }

  getAdmissionDataById(id) {
    return this.http.get(
      environment.baseUrl + `crm/registration/admission/one?id=${id}`
    )
  }

  getAdmissionTimeline(id) {
    return this.http.get(
      environment.baseUrl + `crm/registration/admission/timeline?admissionId=${id}`
    )
  }

  getAdmissionList(businessId: any, pageNo: number, size: number, startDate:any, endDate:any,isFromRegistration:boolean

  ) {
    return this.http.get(
      environment.baseUrl + `crm/registration/admission?businessId=${businessId}&pageNo=${pageNo}&size=${size}&startDate=${startDate}&endDate=${endDate}&isFromRegistration=${isFromRegistration} `
    )
  }
  // getAdmissionList(businessId: any, pageNo: number, size: number) {
  //   return this.http.get(
  //     environment.baseUrl + `crm/registration/admission?businessId=${businessId}&pageNo=${pageNo}&size=${size}`
  //   )
  // }
  searchAdmissionList(payload)
  {
    return this.http.put(
      environment.baseUrl + `crm/registration/admission/getAll` , payload
    )
  }

  createRegistration(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/registration/?enquiryId=${payload?.enquiryId || ''}`, payload
    )
  }

  createRegistrationV2(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/registration/registration/payment`, payload
    )
  }

  getRegistrationList(payload: any) {
    return this.http.put(
      environment.baseUrl + `crm/registration/getAll`, payload
    )
  }

  inActiveRegistration(id: string) {
    return this.http.delete(
      environment.baseUrl + `crm/registration?id=${id}`
    )
  }

  checkPaymentStatus(orderId: any) {
    return this.http.get(
      environment.baseUrl + `crm/registration/manual/payment/status?orderId=${orderId}`
    )
  }

  getPaymentStatus(orderId:any){
    return this.http.post(
      environment.baseUrl+`crm/registration/admission/v2/payment/status/web?orderId=${orderId}`,{}
    )
  }

  getAllDocument(payload: any) {
    return this.http.put(
      environment.baseUrl +  `crm/master/documentType/filter`, payload)
  }

  getAllStudentList(payload)
  {
    return this.http.put(
      environment.baseUrl + `crm/registration/student/filter` , payload
    )
  }


  getAyStudentList(bId:any,ayId:any){
    return this.http.get(
      environment.baseUrl+`crm/registration/student/ay/all?businessId=${bId}&ayId=${ayId}`
    )
  }

  getAllStudents(data:any){
    return this.http.put(
      environment.baseUrl+`crm/registration/student/filter`,data
    )
  }
 
  promoteBulkStudent(payload){
    return this.http.put(
      environment.baseUrl+`crm/registration/bulk-promote`,payload
    )
  }
  
  listPTC(payload){
    return this.http.put(
      environment.baseUrl+`crm/registration/ay-student/list`,payload
    )
  }

  getStudentlistbyAySecGrade(academicYearId:any,gradeId:any,sectionId:any,businessId:any){
    return this.http.get(
      environment.baseUrl+`crm/registration/ay/studentList?academicYearId=${academicYearId}&gradeId=${gradeId}&sectionId=${sectionId}&businessId=${businessId}`
    )
  }
  
  getSingleStudentData(id)
  {
    return this.http.get(
      environment.baseUrl  + `crm/registration/student/${id}`
    )
  }

  uploadDocument(payload) {
    return this.http.put(
      environment.baseUrl + `crm/registration/student/docs/update`, payload
    )
  }

  deleteDocument(payload) {
    return this.http.delete(
      environment.baseUrl + `crm/registration/delete/document?studentId=${payload.studentId}&docType=${payload.docType}`,
    )
  }


  openSocialBrand(componentName: any, height: any, width: any,data:any) {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      data:data,

    });
}

  createcharactercertificate(payload) {
    return this.http.post(
      environment.baseUrl+`crm/certificates/character`, payload
    )
  }

  listcharactercertificate(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/character/list`,payload
    )
  }

  filtercharactercertificate(payload){
    return this.http.put(
      environment.baseUrl+`crm/certificates/character/filter`,payload
    )
  }

  deletecharactercertificate(characterid:any) {
    return this.http.delete(
      environment.baseUrl+`crm/certificates/character?id=${characterid}`
    )
  }

  deleteTransferCertificate(tcId:any){
    return this.http.delete(
      environment.baseUrl+`crm/certificates/transfer?id=${tcId}`
    )
  }

  createtransfercertificate(payload) {
    return this.http.post(
      environment.baseUrl+`crm/certificates/transfer`, payload
    )
  }

  updateTransferCertificate(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/transfer/update`, payload
    )
  }
  changeTCStatus(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/transfer/status?id=${payload.id}&status=${payload.status}`, {}
    )
  }
  listtransfercertificate(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/transfer/list`,payload
    )
  }

  filtertransfercertificate(payload){
    return this.http.put(
      environment.baseUrl+`crm/certificates/transfer/filter`,payload
    )
  }

  createbonafiedcertificate(payload) {
    return this.http.post(
      environment.baseUrl+`crm/certificates/bonafide`, payload
    )
  }
  updateBonafideCertificate(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/bonafide/update`, payload
    )
  }
  changeBonafideStatus(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/bonafide/status?id=${payload.id}&status=${payload.status}`, {}
    )
  }
  updateCharacterCertificate(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/character/update`, payload
    )
  }
  changeCharacterStatus(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/character/status?id=${payload.id}&status=${payload.status}`, {}
    )
  }
  listbonafiedcertificate(payload) {
    return this.http.put(
      environment.baseUrl+`crm/certificates/bonafide/list`,payload
    )
  }

  filterbonafiedcertificate(payload){
    return this.http.put(
      environment.baseUrl+`crm/certificates/bonafide/filter`,payload
    )
  }

  deletebonafiedcertificate(bonafiedid:any) {
    return this.http.delete(
      environment.baseUrl+`crm/certificates/bonafide?id=${bonafiedid}`
    )
  }

  // getdashboarddata(businesssId:any,startDate :any,endDate:any){
  //   return this.http.get(
  //     environment.baseUrl+`crm/registration/admission-dashboard?businessId=${businesssId}&startDate=${startDate}&endDate=${endDate}`
  //     // &startDate=${startDate}&endDate=${endDate}`
  //   )
  // }
  getdashboarddata(businessId: any, startDate?: string, endDate?: string, grade?: string, section?: string, isActive?:boolean, count?:any) {
    let url = environment.baseUrl + `crm/registration/admission-dashboard?businessId=${businessId}`;
  
    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (grade) {
      url += `&grade=${grade}`;
    }
    if (section) {
      url += `&section=${section}`;
    }

    if (isActive !== undefined) {
      url += `&isActive=${isActive}`;
    }    
    if(count){
      url += `&count=${count}`
    }
    return this.http.get(url);
  }
  
  getcertificatelistDashboard(businessId: any, startDate?: string, endDate?: string, grade?: string, section?: string, isActive?:boolean, count?:any){
    let url = environment.baseUrl + `crm/registration/certificates?businessId=${businessId}`;
  
    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (grade) {
      url += `&grade=${grade}`;
    }
    if (section) {
      url += `&section=${section}`;
    }

    if (isActive !== undefined) {
      url += `&isActive=${isActive}`;
    }    
    if(count !== undefined){
      url += `&count=${count}`
    }
    return this.http.get(url);
  }

// Student-penalty apis

createstudentpenalty(payload) {
  return this.http.post(
    environment.baseUrl+`crm/registration/student/penalty`, payload
  )
}

studentpenaltypaymentstatus(Id:string,stId:string, pId:string, paid:boolean, paymentType: string, transactionId:string){
  return this.http.put(
    environment.baseUrl+`crm/registration/student/penalty/status?id=${Id}&studentId=${stId}&penaltyId=${pId}&isPaid=${paid}&paymentMode=${paymentType}&transactionId=${transactionId}`,""
  )
}

deletestudentpenalty(id,penaltyId,ayStudentId,academicYearId){
  return this.http.delete(
    environment.baseUrl+`crm/registration/student/penalty?id=${id}&penaltyId=${penaltyId}&ayStudentId=${ayStudentId}&academicYearId=${academicYearId}`, {}
  )
}

//Student Management Attendance Listing
getStudentAttendanceList(payload) {
    return this.http.put(
      environment.baseUrl + `crm/attendance/filter/class`, payload
    )
}

addStudentRemark(payload: any) {
  return this.http.post(
    `${environment.baseUrl}crm/attendance/remark?id=${payload.id}&remarks=${payload.remarks}&date=${payload.date}`, 
    {} 
  );
}
editStudentInfo(payload: any) {
  return this.http.put(
    `${environment.baseUrl}crm/attendance/edit?remarks=${payload.remarks}&status=${payload.status}`, 
    { 
      dates: [payload.date],
      studentList: [payload.id]
    } 
  );
}

downloadAttendanceAllGrades(payload: any) {
  return this.http.put(
    environment.baseUrl + `crm/attendance/download/class`,
    payload,
    { responseType: 'blob' } 
  );
}

downloadStudentwiseAttendance(payload: any) {
  return this.http.put(
    environment.baseUrl + `crm/attendance/download/day-wise-student`,
    payload,
    { responseType: 'blob' } 
  );
}

listLowAttendance(payload: any){
  return this.http.get(
    environment.baseUrl + `crm/attendance/low?businessId=${payload.businessId}&academicYearId=${payload.academicYearId}&gradeId=${payload.gradeId}&sectionId=${payload.sectionId}`
  );
}

downloadAttendanceByDate(payload: any) {
  return this.http.put(
    environment.baseUrl + `crm/attendance/download/student/attendance`,
    payload,
    { responseType: 'blob' } 
  );
}

uploadAttendanceFile(payload: { file: File, businessId: string, isClass: boolean }) {
  const formData = new FormData();
  formData.append('file', payload.file, payload.file.name);
  
  return this.http.put(
    environment.baseUrl + `crm/attendance/excel/upload?businessId=${payload.businessId}&isClass=${payload.isClass}`, 
    formData,
    {
      reportProgress: true,
      observe: 'events'
    }
  );
}
uploadStudentAttendance(formData: FormData) {
    const headers = new HttpHeaders();
  // formData.append('file', file);
   headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
  return this.http.post(
    environment.baseUrl+`crm/student-attendance/import`, formData, {
  headers: headers,
  observe: 'events',
  responseType: 'text'
  });
}


getStudentWiseAttendanceList(payload){
  return this.http.put(
    environment.baseUrl + `crm/attendance/filter/student`, payload
  )
}

getStudentPenalityList(payload){
  return this.http.put(
    environment.baseUrl+`crm/registration/student/penalty/filter`, payload
  )
}

addConcessionToStudent(payload:any) {
  return this.http.post(
    environment.baseUrl+ `crm/registration/student/concession`, payload
  )
}

getStudentConcessionList(payload){
  return this.http.put(
    environment.baseUrl+`crm/registration/student/concession/filter`, payload
  )
}

deleteStudentConcession(id,concessionId,ayStudentId,academicYearId){
  return this.http.delete(
    environment.baseUrl+`crm/registration/student/concession?id=${id}&concessionId=${concessionId}&ayStudentId=${ayStudentId}&academicYearId=${academicYearId}`, {}
  )
}

//syllabus apis

getSyllabus( businessId:any,gradeId:any){
  return this.http.get(
    environment.baseUrl+`crm/syllabus/${businessId}/grade/${gradeId}`,{}
  )
}
 addSyllabus(data:any){
  return this.http.post(
    environment.baseUrl+`crm/syllabus`,data
  )
 }
 filterSyllabus(data:any){
  return this.http.put(
    environment.baseUrl+`crm/syllabus/filter`,data
  )
 }
 deleteSyllabus(syllabusId:any){
  return this.http.delete(
    environment.baseUrl+`crm/syllabus/${syllabusId}`,{}
  )
 }

 //leave-request apis

 getAllLeaveReqs(payload){
  return this.http.put(
    environment.baseUrl+`crm/leave/list`,payload
  )
 }

 createLeaveReq(payload){
  return this.http.post(
    environment.baseUrl+`crm/leave`,payload
  )
 }
 

 deleteLeaveReq(id: any){
  return this.http.delete(
    environment.baseUrl+`crm/leave?id=${id}`,{}
  )
 }
 getLeaveReqById(id: any){
  return this.http.get(
    environment.baseUrl+`crm/leave?id=${id}`,{}
  )
 }

 editLeaveReq(payload){
  return this.http.put(
    environment.baseUrl+`crm/leave`,payload
  )
 }

 changeLeaveStatus(id:any,status:any,reason:any){
  let remarks = ''
  if(reason)
    remarks = remarks + `&remarks=${reason}`
  return this.http.put(
    environment.baseUrl+`crm/leave/status?id=${id}&status=${status}${remarks}`,{}
  )
 }

 leavereqDashboard(id:any, startDate:any, enddate:any){
  return this.http.get(
    environment.baseUrl+`crm/leave/dashboard-data?businessId=${id}&startDate=${startDate}&endDate=${enddate}`
  )
 }
 //early pickup apis

 createEarlyPickupReq(payload){
  return this.http.post(
    environment.baseUrl+`crm/early-pickup`,payload
  )
 }

 changeEarlyPickupRequestStatus(id:any,status:any,reason:any){
  let remark = ''
  if(reason)
    remark = remark + `&remarks=${reason}`
  return this.http.put(
    environment.baseUrl+`crm/early-pickup/status?id=${id}&status=${status}${remark}`,{}
  )
 }

 getAllEPReq(payload){
  return this.http.put(
    environment.baseUrl+`crm/early-pickup/list`,payload
  )
 }

 deleteEPReq(id:any){
  return this.http.delete(
    environment.baseUrl+`crm/early-pickup?id=${id}`,{}
  )
 }

 getEarlyPickupReqById(id: any){
  return this.http.get(
    environment.baseUrl+`crm/early-pickup?id=${id}`,{}
  )
 }

 earlyPickupDashboard(id:any, start:any,end:any){
  return this.http.get(
    environment.baseUrl+`crm/early-pickup/dashboard-data?businessId=${id}&startDate=${start}&endDate=${end}`
  )
 }

//  changeEPReqStatus(id: any, status:any){
//   return this.http.put(
//     environment.baseUrl+`crm/early-pickup/status?id=${id}&status=${status}`,{}
//   )
//  }

//kit distribution apis

getAllKDList(payload){
  return this.http.put(
    environment.baseUrl+`crm/kit/filter`,payload
  )
}

addKD(payload){
  return this.http.post(
    environment.baseUrl+`crm/kit/issue`,payload
  )
}

getKitDashboardData(warehouseId:any,businessId:any,startDate?:any, endDate?:any){
  let url =     environment.baseUrl+`crm/kit/${businessId}/dashboard?warehouseId=${warehouseId}`
if(startDate && endDate){
  url += `&startDate=${startDate}&endDate=${endDate}`
}
return this.http.put(url, {});}

// deleteKD(payload){
//   return this.http.delete(
//     environment.baseUrl+`crm/kit/issue`,payload
//   )
// }

//warehouse apis

getAllWarehouse(payload){
  return this.http.put(
    environment.baseUrl+`crm/master/warehouse/get-all`,payload
  )
}

statusWarehouse(id:any, isActive:any){
  return this.http.put(
    environment.baseUrl+`crm/master/warehouse/toggle?id=${id}&isActive=${isActive}`,''
  )
}

addWarehouse(payload){
  return this.http.post(
    environment.baseUrl+`crm/master/warehouse/create`,payload
  )
}

updateWarehouse(payload){
  return this.http.put(
    environment.baseUrl+`crm/master/warehouse/update`,payload
  )
}

getWarehousebyId(id:any){
  return this.http.get(
    environment.baseUrl+`crm/master/warehouse/id=${id}`
  )
}
deleteWarehouse(id:any){
  return this.http.delete(
    environment.baseUrl+`crm/master/warehouse/delete?id=${id}`
  )
}

  admissionDocumentUpload = new EventEmitter<any>();

  openServiceDialog(componentName:any, height:any, width:any, maxWidth:any, dataModel:any, position: any = {right:'0px',top:'0px'}) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth:maxWidth,
      data: dataModel,
      disableClose: true,
      position: position,
    });
  }

  openDeleteDialog(componentName: any, height: any, width: any, dataModel: any, maxwidth: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxwidth,
    });
  }
  openRemarksDialog(componentName: any, height: any, width: any, dataModel: any, p0: string) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }

  openDialog(componentName:any, height:any, width:any, dataModel:any, maxWidth: string = '95vw', maxHeight: string = '100vh') {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: false,
      maxWidth: maxWidth,
      position:{top:'0',right:'0'},
      maxHeight: maxHeight
    });
  }

  getAllStudentCategory(data:any){
    return this.http.put(
      environment.baseUrl+`crm/master/category/get-all`,data
    )  
  }

  getAcedemicYearList(data:any){
    if(data.searchText){
      return this.http.put(
        environment.baseUrl+`crm/master/getAcademicYearMasterByCriteria?academicYear=${data.searchText}&businessId=${data.businessId}&page=${data.pageNo}&size=${data.size}&isDeleted=${data.isDeleted}&isPagination=${data.isPagination!=null?data.isPagination:true}&sortOrderAcademicYearMaster=${data.sortOrder}`,{}
      )
    }
    else{
      return this.http.put(
        environment.baseUrl+`crm/master/getAcademicYearMasterByCriteria?businessId=${data.businessId}&page=${data.pageNo}&size=${data.size}&isDeleted=${data.isDeleted}&isPagination=${data.isPagination!=null?data.isPagination:true}&sortOrderAcademicYearMaster=${data.sortOrder}`,{}
      )
    }
  }

  getAcademicYearwiseHistory(businessId: any,studentId : any ) {
    return this.http.get(
      environment.baseUrl+`crm/registration/student/history?businessId=${businessId}&studentId=${studentId}`
    )
  }


  getListStudentOnCategory(data:any){
    if(data.searchText != '' && data.searchText != undefined){
      return this.http.get(
        environment.baseUrl+`crm/registration/segmentation/${data.categoryId}/student-list?academicYearId=${data.academicYearId}&pageNo=${data.pageNo}&size=${data.size}&search=${data.searchText}`
      )
    }
    else{
      return this.http.get(
        environment.baseUrl+`crm/registration/segmentation/${data.categoryId}/student-list?pageNo=${data.pageNo}&size=${data.size}`
      )
    }
  }

  addOrRemoveStudentsToSegmentation(id:any,data:any){
    return this.http.put(
      environment.baseUrl+`crm/registration/segmentation/${id}/update-students`,data
    )
  }
  
}
